//Swiper 4 (5.0からはIE11がサポートされていない)
//import Swiper from 'swiper';// Dom7でIE11エラーのため外部ファイルに
//import Swiper from 'swiper/bundle';


// Swiper 6.0
//import Swiper, { Navigation, Pagination } from 'swiper';


export class Swp {
    constructor() {
        this.swipers = [];
        //Swiper.use([Navigation, Pagination]); // Swiper 6+
    }

    init() {
        //this.body = document.getElementsByTagName('body')[0];
        //this.html = document.getElementsByTagName('html')[0];

        //index cover
        this.swipers.indexSlider = new Swiper('#js-index-cover-swiper', {
            speed: 600, //切り替えトランジション時間
            spaceBetween: 0,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            initialSlide: 0,
            slidesPerView: 1,
            spaceBetween: 0,
            autoplay: false,
            on: {
                init: function () {
                    this.params.autoplay.delay = 2500; //表示時間
                    this.autoplay.start();
                    //console.log('swiper start + delay');
                }
            },
            // pagination: {
            //     el: '.swiper-pagination2',
            // },
            // navigation: {
            // 	nextEl: '.swiper-button-next',
            // 	prevEl: '.swiper-button-prev',
            // },
        });
    }
}